import { AUDIENCE } from "@/lib/audience";
import { Reveal } from "@/components/motion";

export const AudienceSection = ({ eyebrow = "A chi ci rivolgiamo", title = <>Un partner per <span className="text-[#FACC15]">ogni fase</span></>, subtitle }) => (
  <section className="bg-[#0e0e0e] border-y border-[#1a1a1a] py-16 sm:py-32" data-testid="audience-section">
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <Reveal>
        <p className="eyebrow mb-5">{eyebrow}</p>
        <h2
          className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white leading-[1.1] max-w-3xl"
          style={{ fontFamily: "'Outfit', sans-serif", letterSpacing: "-0.025em" }}
          data-testid="audience-h2"
        >
          {title}
        </h2>
        {subtitle && (
          <p className="mt-6 text-white/70 text-lg sm:text-xl max-w-3xl leading-relaxed" data-testid="audience-subtitle">
            {subtitle}
          </p>
        )}
      </Reveal>

      <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4">
        {AUDIENCE.map((a, i) => (
          <Reveal
            key={a.title}
            delay={i * 0.1}
            className="group py-8 lg:py-2 lg:px-8 first:lg:pl-0 last:lg:pr-0 border-t border-[#1f1f1f] lg:border-t-0 lg:border-l lg:border-[#FACC15]/40 first:lg:border-l-0"
            data-testid={`audience-item-${i}`}
          >
            <h3
              className="text-white text-2xl font-bold mb-4 transition-colors group-hover:text-[#FACC15]"
              style={{ fontFamily: "'Outfit', sans-serif" }}
            >
              {a.title}
            </h3>
            <p className="text-white/60 text-base leading-relaxed">{a.desc}</p>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default AudienceSection;
